// extracted by mini-css-extract-plugin
export default {"content":"ModalGetNewVersion_content__hDzH8","buttonStyle":"ModalGetNewVersion_buttonStyle__EMUdy"};